export * from './NewsThumbnailFeature';
